import { theme } from '@chakra-ui/react';

export default {
  defaultPadding: theme.sizes[3],
  defaultMargin: theme.sizes[3],
  defaultScreenX: theme.space[16],
  defaultScreenY: theme.space[16],
};
